/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react"
import PropTypes from "prop-types"
import * as Icon from "react-feather"
import { uniqueId } from "lodash"

const Checkbox = ({
  value,
  className,
  label,
  onChange,
  onFocusOut,
  disable,
  hidden,
  checked,
}) => {
  const htmlId = uniqueId("value-")
  return (
    <div
      className={["form-control", "form-control--checkbox", className].join(
        " "
      )}
    >
      <div className="form-control__faux">
        <input
          id={htmlId}
          type="checkbox"
          className="form-control__input"
          onChange={(e) => {
            const { value, checked } = e.target
            onChange(value, checked)
          }}
          value={value || label}
          disabled={disable}
          hidden={hidden}
          checked={checked}
          onBlur={(e) => {
            onFocusOut(e.target)
          }}
        />
        <div className="form-control__icon">
          <Icon.Check className="icon icon--sm" />
        </div>
      </div>
      {label && (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label
          htmlFor={htmlId}
          className="form-control__label"
          dangerouslySetInnerHTML={{ __html: label }}
        />
      )}
    </div>
  )
}

Checkbox.defaultProps = {
  className: "",
  label: "",
  disable: false,
  hidden: false,
  value: "",
  onChange: () => {},
  onFocusOut: () => {},
  checked: false,
}

Checkbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  disable: PropTypes.bool,
  hidden: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocusOut: PropTypes.func,
  checked: PropTypes.bool,
}

export default Checkbox
